import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Headline5 from '../Typography/Heading/Headline5';
import { ListItem } from '../List';

export const StyledListItem = styled(ListItem)`
  && {
    padding: 16px 16px 16px 0;

    a {
      display: flex;
      align-items: center;
    }
  }
`;

const ImageContainer = styled.div`
  display: inline-block;
  width: 100px;
  padding: 0 16px 0 0;
`;

const MarketListItem = ({ title, image }) => (
  <StyledListItem tag="div">
    <ImageContainer>
      {image}
    </ImageContainer>
    <Headline5 tag="h2">
      {title}
    </Headline5>
  </StyledListItem>
);

MarketListItem.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.node,
};

MarketListItem.defaultProps = {
  image: undefined,
};

export default MarketListItem;
